import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/social/whatsapp.svg'


const _withScopeId = n => (_pushScopeId("data-v-300ea838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "whats-app" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "side left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Ready to discuss your "),
  /*#__PURE__*/_createElementVNode("span", null, "future"),
  /*#__PURE__*/_createTextVNode("?")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Call us directly right now!", -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "WhatsApp"
}, null, -1))
const _hoisted_8 = { class: "side right" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("a", {
            class: "btn",
            href: _ctx.whatsApp,
            target: "_blank"
          }, [
            _hoisted_7,
            _createTextVNode(" WhatsApp ")
          ], 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          class: "icon big",
          src: require('@/assets/img/home/whatsapp.svg')
        }, null, 8, _hoisted_9)
      ])
    ])
  ]))
}